import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { StorageService } from '@c4/core';
import { Router } from '@angular/router';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.less']
})
export class IntroductionComponent extends BaseRoutingComponent implements OnInit {

  constructor(
    private storage: StorageService,
    protected router: Router,
    protected store: Store<any>
  ) {
    super();
  }

  ngOnInit() {
  }

  tryItNow() {
    this.storage.set('proceedWithCaution', true);
    this.router.navigate(['when-then/start'], {relativeTo: this.moduleRoot});
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/introduction/introduction.component.ts